import { GridColumnV2 } from '@schenck/rotec-components';
import { Tenant } from '../models/tenant.model';
import { GridConfig } from '../models/grid-config.model';

export enum TenantKeys {
  name = 'name',
  users = 'users',
  machines = 'machines',
  created = 'created',
}

export const TENANT_GRID_COLUMNS: GridColumnV2[] = [
  {
    key: TenantKeys.name,
    title: 'Name',
    sortable: true,
  },
  {
    key: TenantKeys.users,
    title: 'Users',
    sortable: false,
  },
  {
    key: TenantKeys.machines,
    title: 'Machines',
    sortable: false,
  },
  {
    key: TenantKeys.created,
    title: 'Created',
    sortable: false,
  },
] as GridColumnV2[];

export const TENANT_GRID_CONFIG_DEFAULT: GridConfig = {
  displayedColumns: [TenantKeys.name, TenantKeys.users, TenantKeys.machines, TenantKeys.created],
  columnOrder: [TenantKeys.name, TenantKeys.users, TenantKeys.machines, TenantKeys.created],
  columnsWidths: {
    [TenantKeys.name]: 500,
    [TenantKeys.users]: 400,
    [TenantKeys.machines]: 400,
    [TenantKeys.created]: 500,
  },
};

export const MOCK_TENANTS: Tenant[] = [
  {
    id: 'tenant1',
    name: 'Tenant 1',
    countOfUsers: 11,
    countOfDevices: 22,
    created: '05.05.2222 - 16:40',
  },
  {
    id: 'tenant2',
    name: 'Tenant 3',
    countOfUsers: 15,
    countOfDevices: 26,
    created: '02.04.2222 - 22:22',
  },
  {
    id: 'tenant3',
    name: 'Tenant 2',
    countOfUsers: 14,
    countOfDevices: 23,
    created: '18.03.2222 - 21:11',
  },
  {
    id: 'tenant4',
    name: 'Tenant 4',
    countOfUsers: 17,
    countOfDevices: 3,
    created: '15.04.2222 - 13:44',
  },
  {
    id: 'tenant5',
    name: 'Tenant 5',
    countOfUsers: 12,
    countOfDevices: 6,
    created: '04.05.2222 - 16:43',
  },
  {
    id: 'tenant6',
    name: 'Tenant 6',
    countOfUsers: 16,
    countOfDevices: 16,
    created: '22.02.2222 - 11:33',
  },
  {
    id: 'tenant7',
    name: 'Tenant 7',
    countOfUsers: 11,
    countOfDevices: 15,
    created: '15.03.2222 - 10:40',
  },
  {
    id: 'tenant8',
    name: 'Tenant 8',
    countOfUsers: 13,
    countOfDevices: 11,
    created: '15.01.2222 - 12:14',
  },
];
